export default __webpack_public_path__ + "static/media/map.fcbb0077.png";